import React from 'react';
import { motion, useInView } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import * as FaIcons from 'react-icons/fa';

const { FiMail } = FiIcons;
const { FaInstagram, FaYoutube, FaSpotify, FaApple } = FaIcons;

const Contact = () => {
  const ref = React.useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const socialLinks = [
    {
      icon: FaInstagram,
      name: 'Instagram',
      href: 'https://www.instagram.com/cam_go_crazypodcast/?igsh=MTQyYXdlbGRpNGcycw%3D%3D'
    },
    {
      icon: FaYoutube,
      name: 'YouTube',
      href: 'https://www.youtube.com/@camgocrazy_bossatheart/videos'
    },
    {
      icon: FaSpotify,
      name: 'Spotify',
      href: 'https://open.spotify.com/show/1tuj8UXzDHXLNFsdZGeS8O?si=130d720291e44810'
    },
    {
      icon: FaApple,
      name: 'Apple Podcasts',
      href: 'https://podcasts.apple.com/us/podcast/boss-at-heart-from-pain-to-purpose/id1517815773'
    }
  ];

  return (
    <section className="section py-16 sm:py-20 md:py-24 bg-black text-white" ref={ref}>
      <div className="container px-4">
        <motion.div
          className="text-center max-w-4xl mx-auto"
          initial={{ y: 50, opacity: 0 }}
          animate={isInView ? { y: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl sm:text-4xl md:text-6xl font-bold mb-6 sm:mb-8">
            Let's Connect.
          </h2>

          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-6 sm:mb-8 leading-relaxed">
            For bookings, interviews, or brand opportunities — reach out directly.
          </p>

          {/* Email Icon Link */}
          <motion.div
            className="mb-8 sm:mb-12"
            initial={{ y: 30, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <a
              href="mailto:camariacasher@yahoo.com"
              className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-red-500 rounded-full text-white hover:bg-red-600 transition-all hover:scale-110 shadow-2xl"
            >
              <SafeIcon icon={FiMail} className="text-2xl sm:text-3xl" />
            </a>
          </motion.div>

          {/* Social Icons */}
          <motion.div
            className="flex justify-center gap-4 sm:gap-6 mb-8 sm:mb-12"
            initial={{ y: 30, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            {socialLinks.map((social, index) => (
              <motion.a
                key={social.name}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 sm:w-12 sm:h-12 bg-gray-800 rounded-full flex items-center justify-center text-white hover:bg-red-500 hover:text-white transition-all cursor-pointer"
                whileHover={{ scale: 1.1, y: -3 }}
                initial={{ y: 30, opacity: 0 }}
                animate={isInView ? { y: 0, opacity: 1 } : {}}
                transition={{ duration: 0.6, delay: 0.7 + index * 0.1 }}
              >
                <SafeIcon icon={social.icon} className="text-lg sm:text-xl" />
              </motion.a>
            ))}
          </motion.div>

          {/* Footer */}
          <motion.div
            className="border-t border-gray-800 pt-6 sm:pt-8"
            initial={{ y: 30, opacity: 0 }}
            animate={isInView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <p className="text-gray-400 mb-3 sm:mb-4 text-sm sm:text-base">
              © 2025 Boss At Heart Podcast — Cam Go Crazy. All Rights Reserved.
            </p>
            <p className="text-red-500 italic text-base sm:text-lg font-medium">
              "Keep your hustle strong and your heart louder."
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;